<template>
  <bita-modal
    id="setting-modal"
    title="تنظیمات"
    :modal-sm="false"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-ibox :is-loading="isLoadingModal">
        <div slot="body">
          <bita-form ref="form">
            <div slot="body">
              <div class="row" v-if="$acl.isOwner">
                <bita-input
                  ref="loading_fee"
                  name="loading_fee"
                  :label="$currencyLabel('هزینه بارگیری')"
                  rules="required|fee"
                  validation-container-class="col-12"
                  input-class="form-control"
                  v-model="dataForm.loading_fee"
                  :has-thousand-seprator="true"
                />

                <bita-select
                  id="originstate"
                  name="state"
                  label="استان"
                  ref="originStateDropDown"
                  validation-container-class="col-lg-6 col-md-6 col-sm-6"
                  input-class="form-control"
                  :data-source="state"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.province_id"
                  @change="(e) => this.getCityOrgin(e)"
                />

                <Spinner
                  :is-loading="isLoadingCitiesOrgin"
                  class-name="col-lg-6 col-md-6 col-sm-6"
                  styleName="align-self: center;"
                />

                <bita-select
                  name="citiesOrgin"
                  label="شهر"
                  ref="citiesOrginDropDown"
                  validation-container-class="col-lg-6 col-md-6 col-sm-6"
                  input-class="form-control"
                  :data-source="citiesOrgin"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.city_id"
                />

                <bita-select
                  name="categoryLoads"
                  label="دسته بندی نوع بار"
                  ref="categoryLoadsDropDown"
                  validation-container-class="col-lg-6 col-md-12 col-sm-12"
                  input-class="form-control"
                  :data-source="categoryLoads"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.category_loads_id"
                  @change="(e) => this.getLoads(e)"
                />

                <Spinner
                  :is-loading="isLoadingLoads"
                  class-name="col-lg-6 col-md-12 col-sm-12"
                  styleName="align-self: center;"
                />

                <bita-select
                  v-if="this.isLoadingLoads === false"
                  name="loads"
                  label="نوع بار"
                  ref="loadsDropDown"
                  rules=""
                  validation-container-class="col-lg-6 col-md-12 col-sm-12"
                  input-class="form-control"
                  :data-source="loads"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.load_id"
                />

                <bita-select
                  name="categoryVehicleTypes"
                  label="دسته بندی نوع ماشین"
                  ref="categoryVehicleTypesDropDown"
                  validation-container-class="col-lg-6 col-md-12 col-sm-12"
                  input-class="form-control"
                  :data-source="categoryVehicleTypes"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.category_vehicle_type_id"
                  @change="(e) => this.getVehicleTypes(e)"
                />

                <Spinner
                  :is-loading="isLoadingVehicleTypes"
                  class-name="col-lg-6 col-md-12 col-sm-12"
                  styleName="align-self: center;"
                />

                <bita-select
                  v-if="this.isLoadingVehicleTypes === false"
                  name="vehicleTypes"
                  label="نوع ماشین"
                  ref="vehicleTypesDropDown"
                  validation-container-class="col-lg-6 col-md-12 col-sm-12"
                  input-class="form-control"
                  :data-source="vehicleTypes"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.vehicle_type_id"
                />

              </div>
            </div>
          </bita-form>
        </div>
      </bita-ibox>
    </div>
    <div slot="footer">
      <bita-bootbutton
        type="primary"
        title="ذخیره"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleSubmit()"
      />
    </div>
  </bita-modal>
</template>
<script>
import Spinner from "../../components/Spinner";

export default {
  components: {
    Spinner
  },
  props: {
    settings: {},
  },
  data() {
    return {
      colWidth: "col-lg-12",
      dataForm: {},
      isLoading: false,
      categoryLoads: [],
      categoryVehicleTypes: [],
      isLoadingLoads: false,
      isLoadingVehicleTypes: false,
      isLoadingCitiesOrgin: false,
      isLoadingModal: false,
      loads: [],
      vehicleTypes: [],
      state: [],
      citiesOrgin: []
    };
  },
  watch: {
    //
  },
  mounted() {
    const vm = this;
    this.$root.$on("setting:modal", function(_setting) {
      vm.settingConfig(_setting);
    })
  },
  beforeDestroy() {
    this.$root.$off("setting:modal");
  },
  methods: {
    getState() {
      this.$persistClient("get", "cities?filter[province]=0")
        .then((res) => {
          this.state = res.data;
        })
        .finally(() => {});
    },
    settingConfig(_setting) {
      this.isLoadingModal = true;
      this.getCategoryLoads();
      this.getCategoryVehicleTypes();
      this.getState();
      if ( _setting.settings && _setting.settings.category_loads_id )
        this.getLoads(_setting.settings.category_loads_id);

      if ( _setting.settings && _setting.settings.category_vehicle_type_id )
        this.getVehicleTypes(_setting.settings.category_vehicle_type_id);

      if ( _setting.settings && _setting.settings.province_id )
        this.getCityOrgin(_setting.settings.province_id )

      const vm = this
      setTimeout( function(){
        if ( _setting.settings )
          vm.dataForm = _setting.settings;
        vm.isLoadingModal = false;
      },500)
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.isLoading = true;
          let data = {
            settings: {
              category_loads_id: this.dataForm.category_loads_id ? this.dataForm.category_loads_id : null,
              load_id: this.dataForm.load_id ? this.dataForm.load_id : null,
              category_load_id: this.dataForm.category_load_id ? this.dataForm.category_loads_id : null,
              vehicle_type_id: this.dataForm.vehicle_type_id ? this.dataForm.vehicle_type_id : null,
              category_vehicle_type_id: this.dataForm.category_vehicle_type_id ? this.dataForm.category_vehicle_type_id : null,
              city_id: this.dataForm.city_id ? this.dataForm.city_id : null,
              province_id: this.dataForm.province_id ? this.dataForm.province_id : null,
              loading_fee: this.dataForm.loading_fee ? this.dataForm.loading_fee : null,
            },
          }
          this.$persistClient("patch", "users/current/settings", data)
            .then((res) => {
              this.$izitoast("success", "موفق", res.data.message);
              this.$toggleModal("#setting-modal");
              this.$store.dispatch("logout");
              this.$router.push("/login");
            })
            .finally(() => (this.isLoading = false));
        }
      });
    },
    reset() {
      this.dataForm = {};
    },
    onCloseModal(e) {
      this.reset();
    },
    getCategoryLoads() {
      this.$persistClient("get", `loads?filter[parentItem]=0&include=parentItem`)
        .then((res) => {
          this.categoryLoads = res.data;
        })
        .finally(() => {});
    },
    getLoads(categoryId) {
      this.isLoadingLoads = true;
      this.$persistClient("get", `loads?filter[parentItem]=${categoryId}`)
        .then((res) => {
          this.loads = res.data;
        })
        .finally(() => {
          this.isLoadingLoads = false;
        });
    },
    getVehicleTypes(categoryId) {
      this.isLoadingVehicleTypes = true;

      this.$persistClient("get", `vehicle-types?filter[parent]=${categoryId}`)
        .then((res) => {
          this.vehicleTypes = res.data;
        })
        .finally(() => {
          this.isLoadingVehicleTypes = false;
        });
    },
    getCategoryVehicleTypes() {
      this.$persistClient("get", `vehicle-types?filter[parent]=0`)
        .then((res) => {
          this.categoryVehicleTypes = res.data;
        })
        .finally(() => {});
    },
    getCityOrgin(stateId) {
      this.isLoadingCitiesOrgin = true;
      this.$persistClient("get", `cities?filter[province]=${stateId}`)
        .then( (res) => {
          this.citiesOrgin = res.data
        })
        .finally( () => this.isLoadingCitiesOrgin = false)
    },
  }
};
</script>
